import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { Translate } from "@/redux/modules/value/translations/translations.provider";

import { TooltipType } from "./eCommerce.types";

const broadcastAddToCartNotAvailableForServiceProduct = (t: Translate) =>
    broadcastMessage({
        id: "pdp-error",
        text: t("general.message.addToCartNotAvailableForServiceProduct"),
        status: "info",
        dismissible: true
    });

const validateTooltip = (
    tooltip: TooltipType | undefined
): TooltipType | undefined => {
    if (tooltip?.text) {
        return tooltip;
    }

    return undefined;
};

export { broadcastAddToCartNotAvailableForServiceProduct, validateTooltip };
